import * as React from "react";
import { Modal, Button, Input, TextArea, Link } from "@forge/common";
import "../../../features/components/header/header.scss";

interface FeedbackModalProps {
  feedbackPopOpen: boolean;
  setFeedbackPopOpen: (open: boolean) => void;
  feedbackSubjectInput: string;
  setFeedbackSubject: (subject: string) => void;
  setFeedbackText: (text: string) => void;
  feedbackText: string;
  submitFeedback: () => void;
}

export const FeedbackModal = (props: FeedbackModalProps) => {
  const handleClose = () => {
    props.setFeedbackPopOpen(false);
    props.setFeedbackSubject("");
    props.setFeedbackText("");
  };

  return (
    <div className="feedback-modal" role="dialog" data-testid="feedback-modal">
      <Modal
        className="feedback-modal"
        data-testid="feedback-modal"
        backdrop
        footerRight={
          <Button
            disabled={
              props.feedbackSubjectInput === "" || props.feedbackText === ""
            }
            onClick={props.submitFeedback}
            id="feedback-submit-button"
            data-testid="feedback-submit-button"
          >
            Submit
          </Button>
        }
        //   onBackdropClick={() => props.setFeedbackPopOpen(false)}
        onModalClose={handleClose}
        title="Suggestions/Feedback"
      >
        <div className="feedback-textarea-wrapper">
          <label className="feedback-subject">Subject</label>
          <Input
            id="feedback-subject-input"
            size="regular"
            placeholder="Enter Subject"
            onChange={(e: any) => {
              const whitelistRegex = /^[a-zA-Z0-9\s.,_-]*$/;
              const inputValue = e.target.value;
              if (whitelistRegex.test(inputValue)) {
                props.setFeedbackSubject(inputValue);
              }
            }}
            value={props.feedbackSubjectInput}
            maxLength={250}
            data-testid="feedback-subject-input"
            required
            className="feedback-subject-input"
            autoComplete="off"
          />
          <label className="feedback-maxLength">Max 250 Characters</label>
          <label className="feedback-subject">
            Please Enter Suggestions/Feedback (1000 Characters Max)
          </label>
          <TextArea
            id="feedback-suggestion-input"
            size="regular"
            placeholder="Start typing here..."
            onChange={(e: any) => {
              const whitelistRegex = /^[a-zA-Z0-9\s.,_-]*$/;
              const inputValue = e.target.value;
              if (whitelistRegex.test(inputValue)) {
                props.setFeedbackText(inputValue);
              }
            }}
            value={props.feedbackText}
            maxLength={1000}
            data-testid="feedback-suggestion-input"
            required
            className="feedback-subject-input"
            autoComplete="off"
          />
          <label className="feedback-subject-link">
            For technical issues or support please click the link below.
          </label>
          <Link
            href="https://process.honeywell.com/us/en/support/submit-support-request"
            target="_blank"
            rel="noopener noreferrer"
            className="feedback-link"
          >
            https://process.honeywell.com/us/en/support/submit-support-request
          </Link>
        </div>
      </Modal>
    </div>
  );
};

export const FeedbackModalConfirmation = (props: any) => {
  return (
    <Modal
      backdrop
      data-testid="feedback-confirmation-modal"
      title="Suggestions/Feedback"
      className="feedback-modal-confirmation"
      footerRight={
        <Button
          onClick={props.handleClose}
          id="feedback-confirmation-button"
          data-testid="feedback-confirmation-button"
          className="feedback-confirmation-button"
        >
          Ok
        </Button>
      }
      onModalClose={props.handleClose}
    >
      {props.feedBackStatus === 200 ||
      props.feedBackStatus === 201 ||
      props.feedBackStatus === 204 ||
      props.feedBackStatus === 202 ? (
        <div className="feedback-success-message">
          Thank you for your feedback!
        </div>
      ) : (
        <div className="feedback-error-message">
          There was an error submitting your feedback. Please try again later.
        </div>
      )}
    </Modal>
  );
};
